<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Delete FAQ(s)</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-3"><h2>This faq will be deleted from ALL languages</h2></v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-row class="pa-2 ma-0">
                    <v-col cols=2 class="pa-2">Category</v-col><v-col cols=10 class="pa-2">{{ faq.categoryCode }}</v-col>
                    <v-col cols=2 class="pa-2">Question</v-col><v-col cols=10 class="pa-2"><v-textarea v-model="faq.question" rows="4" disabled dense></v-textarea></v-col>
                    <v-col cols=2 class="pa-2">Answer  </v-col><v-col cols=10 class="pa-2"><v-textarea v-model="faq.answer" rows="4" disabled dense></v-textarea></v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="deleteFaq">Comfirm Delete</v-btn>
                <v-btn color="primary" small @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                faq: {},
            }
        },
        methods: { 
            openDialog(faq) {
                this.faq = faq;
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            deleteFaq() {
                this.$axios.post("ares/json/ares/syst/openai/deleteFaqGeneral.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteFaqGeneral",
                    },
                    deleteFaqGeneral: {
                        oava_encrid: this.faq.oava_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteFaqGeneral.text,
                            color: res.data.deleteFaqGeneral.color,
                        });
                        this.$emit("actionClick", "refresh")
                        this.closeDialog();
                    }
                });
            },
        }
    }
</script>